import React from 'react'
import { PlayButton } from './PlayButton';
import MarketingContext from '../../../contexts/MarketingContext';

export const DrawNumber = ({play, group, number}) => {

  let {
          onDrawNumber,
      } = React.useContext(MarketingContext);
 
  return (
   
    <div>
  
     <PlayButton play = {play} onClick={() => {onDrawNumber(group, number)}} label =  {number}/>
        
        
    </div> 

  )
}
  